import type { StepConfig } from '@/types'

export const STEPS: StepConfig[] = [
  {
    id: 'debt',
    fieldId: 'debtAmount',
    inputType: 'slider',
    botMessage: "Hi there! I'm here to help you find debt relief options.\n\nLet's start by understanding your situation. How much debt do you currently have?",
  },
  {
    id: 'employment',
    fieldId: 'income',
    inputType: 'buttons',
    botMessage: "Great! What's your current employment status?",
    options: [
      { text: 'Full Time', value: '5500' },
      { text: 'Part Time', value: '2500' },
      { text: 'Retired', value: '2500' },
      { text: 'Unemployed', value: '0' },
    ],
  },
  {
    id: 'name',
    fieldId: 'firstName',
    inputType: 'name',
    botMessage: (data) => {
      const debt = data.debtAmount || 0
      const income = parseInt(data.income || '0', 10)
      if (debt >= 10000 && income >= 2000) {
        return "Based on your answers, you could potentially eliminate up to 50% of your debt!\n\nLet's get your personalized results. What's your name?"
      }
      return "Let's continue with your information. What's your name?"
    },
  },
  {
    id: 'email',
    fieldId: 'email',
    inputType: 'email',
    botMessage: (data) => `Thanks ${data.firstName || 'there'}! What's your email address?`,
  },
  {
    id: 'address',
    fieldId: 'address',
    inputType: 'address',
    botMessage: "What's your mailing address? This helps us find specific solutions in your area.",
  },
  {
    id: 'dob',
    fieldId: 'dobMonth',
    inputType: 'dob',
    botMessage: "What's your date of birth?",
    triggerCreditPull: true,
  },
  {
    id: 'phone',
    fieldId: 'phone',
    inputType: 'phone',
    botMessage: (data) => `Almost done ${data.firstName || 'there'}! What's the best phone number to reach you?`,
    showTcpa: true,
  },
]
